import { __assign, __rest } from "tslib";
import React from 'react';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { getDeviationUrl, getDeviationResourceType, } from '../../../../../_helpers';
import { useOverlayContext } from '../../../../../hooks/useOverlayContext';
import OverlayCommentControl from '../../../../../Helper/OverlayCommentControl';
var CommentControl = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, hasCommentedOn = _a.hasCommentedOn, props = __rest(_a, ["deviation", "hasCommentedOn"]);
    var showStats = useOverlayContext(deviation).showStats;
    return (React.createElement(OverlayCommentControl, __assign({}, props, { showStats: showStats, href: "".concat(getDeviationUrl(deviation), "#comments"), stat: deviation.stats && deviation.stats.comments, hasCommentedOn: hasCommentedOn, biData: BiData({
            evid: 105,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            creatorid: (_c = (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid) !== null && _c !== void 0 ? _c : '',
            sectionname: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
        }) })));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map